/**
 * Given a disambiguated filters object, returns the dynamic subtitle to use for
 * the chart.
 * @param {object} disambiguatedFilters - A disambiguated filters object describing current filters.
 * @returns {string} The chart subtitle.
 */
const getChartSubtitle = ({
  serviceType,
  sourceOfFunds,
}) => `On ${serviceType.join(', ')} by ${sourceOfFunds.join(', ')}`;

export default getChartSubtitle;
